var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoyseat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5672 21.9946C17.5672 22.7621 16.9456 23.3837 16.1858 23.3837H1.38911C0.621645 23.3837 0 22.7621 0 21.9946C0 17.1443 3.93708 13.2072 8.78745 13.2149C13.6378 13.2149 17.5672 17.1443 17.5672 21.9946Z",
    fill: "#0008EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99121 4.78897C3.99121 2.14122 6.14011 0 8.78018 0C11.4202 0 13.5691 2.14889 13.5691 4.78897C13.5691 7.43671 11.4279 9.57793 8.78018 9.57793C6.14011 9.57793 3.99121 7.43671 3.99121 4.78897Z",
    fill: "#0008EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyseat);
export default __webpack_public_path__ + "static/media/boyseat.d3c45a1cd29400fbdfacde3dbfa412a6.svg";
export { ForwardRef as ReactComponent };